<template>
    <div>
        <!--<br>-->
        <!--<select v-model="selectedHour">-->
        <!--<option-->
        <!--v-for="item in hourOptions"-->
        <!--:key="item.key"-->
        <!--:label="item.label"-->
        <!--:value="item.value">-->
        <!--</option>-->
        <!--</select>-->
        <!--:-->
        <!--<select v-model="selectedMinute">-->
        <!--<option-->
        <!--v-for="item in minuteOptions"-->
        <!--:key="item.key"-->
        <!--:label="item.label"-->
        <!--:value="item.value">-->
        <!--</option>-->
        <!--</select>-->
        <!--<select v-model="selectedPeriod">-->
        <!--<option value="AM">AM</option>-->
        <!--<option value="PM">PM</option>-->
        <!--</select>-->

        <br>

        <!-- TEST -->

        <div class="mySelect">
            <b-form-select v-model="selectedHour">
                <option
                        v-for="item in hourOptions"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value">
                </option>
            </b-form-select>
            <span>:</span>
            <b-form-select v-model="selectedMinute">
                <option
                        v-for="item in minuteOptions"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value">
                </option>
            </b-form-select>
            <b-form-select v-model="selectedPeriod">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
            </b-form-select>

        </div>

    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: "TimePicker",
        props: {
            value: String,
            pickerOptions: {
                type: Object,
                default: () => ({
                    start: 1,
                    end: 12,
                    interval: 5
                })
            }
        },
        data() {
            return {
                selectedTime: this.timeValue,
                selectedHour: '',
                selectedMinute: '',
                selectedPeriod: '',
                hourOptions: [],
                minuteOptions: []
            }

        },
        methods: {

            populateHourPicker(options) {
                for (let i = options.start; i <= options.end; i++) {
                    let option = {value: i.toString().padStart(2, '0'), label: i.toString().padStart(2, '0'), key: i};
                    this.hourOptions.push(option);
                }
            },
            populateMinutePicker(options) {

                let minute = 0;
                while (minute < 60) {
                    let option = {
                        value: minute.toString().padStart(2, '0'),
                        label: minute.toString().padStart(2, '0'),
                        key: minute
                    };
                    this.minuteOptions.push(option);
                    minute += options.interval;
                }
            },
            validateHourPickerOptions() {

                if (this.pickerOptions == null)
                    return false;

                if (this.pickerOptions.start == null)
                    return false;
                if (this.pickerOptions.end == null)
                    return false;

                if (this.pickerOptions.start < 0 || this.pickerOptions.start > 12)
                    return false;

                return !(this.pickerOptions.end < 0 || this.pickerOptions.end > 12);
            },
            validateMinutePickerOptions() {
                if (this.pickerOptions == null)
                    return false;

                if (this.pickerOptions.interval == null)
                    return false;

                if (this.pickerOptions.interval < 0)
                    return false;

                return 60 % this.pickerOptions.interval === 0;
            },
	        defaultTime(val) {

		        if (val !== "") {
			        this.selectedTime = moment(`${this.selectedHour}:${this.selectedMinute} ${this.selectedPeriod}`, ["h:mm A"]).format("HH:mm");
			        this.defaultEmit();
		        }
	        },
	        defaultEmit() {
		        this.$emit('input', this.selectedTime);
	        }
        },
        watch: {
            selectedTime: function (val) {

                if (val === "") {
                    this.selectedPeriod = '';
                    this.selectedHour = '';
                    this.selectedMinute = '';
	                this.defaultEmit();
                    return;
                }

                if (moment(val.toString(), 'HH:mm').isValid()) {
                    let m = moment(val.toString(), 'hh:mm A');
                    this.selectedPeriod = m.format("A");
                    this.selectedHour = m.format("hh");
                    this.selectedMinute = m.format("mm");
                }


                // this.selectedTime = `${this.selectedHour}:${this.selectedMinute}`;
	            this.defaultEmit();
            },
            selectedHour: function (val) {

	            this.defaultTime(val);
            },
            selectedMinute: function (val) {

	            this.defaultTime(val);
            },
            selectedPeriod: function (val) {

                this.defaultTime(val);
            }
        },

        mounted() {
            if (moment(this.value, 'HH:mm').isValid()) {
                this.selectedTime = this.value;
                let m = moment(this.selectedTime, 'hh:mm A');
                this.selectedPeriod = m.format("A");
                this.selectedHour = m.format("HhhH");
                this.selectedMinute = m.format("mm");

            }
            else {
                this.selectedTime = "";
                this.selectedPeriod = "";
                this.selectedHour = "";
                this.selectedMinute = "";

            }
        },
        created() {

            if (this.validateHourPickerOptions()) {
                this.populateHourPicker(this.pickerOptions);
            }
            if (this.validateMinutePickerOptions()) {
                this.populateMinutePicker(this.pickerOptions);
            }
        }
    }

</script>


<style scoped lang="scss">

    .mySelect {
        height: 38px;
        width: 60px;
        display: flex;
        flex-direction: row;

        select {
            /*background: #319e5e;*/
            width: 180px;
            height: 38px;
            font-size: 16px;
            border-radius: 0 !important;
            padding-right: 30px;
            text-align: center !important;
            outline: none;

            option {
                font-size: 58px !important;
            }

        }

        .custom-select {
            margin-left: 5px;
        }

        span {
            margin-left: 5px;
            text-align: center;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/TimePickerCompomponent.vue